export default "__VITE_ASSET__398e8a0f__"